import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Grid, Box, MenuItem } from '@mui/material'

import { useBonusFilters } from '@/views/bonus-engine/hooks'
import { BonusType } from '@/enums/be-bonus-type.enum'
import { BonusTriggerType } from '@/enums/be-bonus-trigger-type.enum'

import keys from '@/utils/keys'

export const BonusFilters = () => {
  const { t } = useTranslation()

  const { filters, handleChangeSearch } = useBonusFilters()

  const triggerByOptions = [
    ...keys(BonusTriggerType)
      .filter(
        (item) =>
          typeof BonusTriggerType[item] !== 'string' &&
          (BonusTriggerType[item] === BonusTriggerType.DEPOSIT_BY_CLICK ||
            BonusTriggerType[item] === BonusTriggerType.GAMIFICATION ||
            BonusTriggerType[item] === BonusTriggerType.BY_REGISTRATION ||
            BonusTriggerType[item] === BonusTriggerType.BY_CODE ||
            BonusTriggerType[item] === BonusTriggerType.BY_BUNDLE),
      )
      // typeof BonusTriggerType[item] !== 'string' &&
      //         BonusTriggerType[item] !== BonusTriggerType.MANUAL &&
      //   BonusTriggerType[item] !== BonusTriggerType.GAMIFICATION &&
      //   BonusTriggerType[item] !== BonusTriggerType.BY_REGISTRATION &&
      //   BonusTriggerType[item] !== BonusTriggerType.BY_CODE) ||
      // (env === 'stg' &&
      //   typeof BonusTriggerType[item] !== 'string' &&
      //   BonusTriggerType[item] !== BonusTriggerType.MANUAL),

      .map((index) => {
        return (
          <MenuItem key={index} value={BonusTriggerType[index]}>
            {t(`bonusTriggerTypes.${index}`)}
          </MenuItem>
        )
      }),
  ]

  const INCLUDED_BONUS = ['CASINO_STANDARD', 'FREE_SPINS']

  const bonusTypes = [
    ...keys(BonusType)
      .filter(
        (item) =>
          typeof BonusType[item] !== 'number' && INCLUDED_BONUS.includes(item),
      )
      .map((x) => ({
        index: BonusType[x],
        label: x,
      })),
  ].sort((a, b) => a.label.localeCompare(b.label))

  // const bonusTypes = [
  //   ...keys(BonusType)
  //     .filter(
  //       (item) =>
  //         typeof BonusType[item] !== 'number' &&
  //         ((env === 'prod' &&
  //           (item === 'CASINO_STANDARD' ||
  //             item === 'FREE_SPINS' ||
  //             // item === 'FREE_PLAY' ||
  //             item === 'BETSOFT_CASINO')) ||
  //           (env === 'stg' &&
  //             (item === 'CASINO_STANDARD' ||
  //               item === 'FREE_SPINS' ||
  //               // item === 'FREE_PLAY' ||
  //               item === 'BETSOFT_CASINO'))),
  //     )
  //     .map((x) => {
  //       return {
  //         index: BonusType[x],
  //         label: x,
  //       }
  //     }),
  // ].sort((a, b) => a.label.localeCompare(b.label))

  const bonusTypesOptions = bonusTypes.map((type) => {
    return (
      <MenuItem key={type.index} value={type.index}>
        {t(`bonusTypes.${type.label}`)}
      </MenuItem>
    )
  })

  return (
    <Box>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            autoComplete="off"
            fullWidth
            name="name"
            label={t('labels.searchByName')}
            margin="dense"
            variant="outlined"
            value={filters?.name || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeSearch('name', e.target.value.trimStart(), true)
            }}
            InputProps={{
              inputProps: {
                maxLength: 100,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            autoComplete="off"
            fullWidth
            name="code"
            label={t('labels.code')}
            margin="dense"
            variant="outlined"
            value={filters?.code || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeSearch('code', e.target.value.trimStart(), true)
            }}
            InputProps={{
              inputProps: {
                maxLength: 100,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            fullWidth
            name="triggerBy"
            margin="dense"
            variant="outlined"
            label={t('labels.triggerType')}
            value={filters?.triggerBy || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeSearch('triggerBy', e.target.value)
            }}
            select
          >
            <MenuItem value="">
              <Box fontStyle="italic">{t('all')}</Box>
            </MenuItem>
            {triggerByOptions}
          </TextField>
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            fullWidth
            name="bonusType"
            margin="dense"
            variant="outlined"
            label={t('labels.bonusType')}
            value={filters?.bonusType || ''}
            onChange={(e: React.ChangeEvent<{ value: string }>) => {
              handleChangeSearch('bonusType', e.target.value)
            }}
            select
          >
            <MenuItem value="">
              <Box fontStyle="italic">{t('all')}</Box>
            </MenuItem>
            {bonusTypesOptions}
          </TextField>
        </Grid>
      </Grid>
    </Box>
  )
}
